module.exports = __webpack_public_path__ + "static/media/dashboardini-react-app-by-saad.firebaseapp.com_(iPhone 6_7_8 Plus) (2).d4a0eb2e.png";